const selectTableSplit = {
  tables: {
    searchPlaceholder: 'חיפוש',
  },
};

export default selectTableSplit;
